export const ROUTE_PREFIX_TRIMMED = "fmg";

export const ROUTE_PREFIX_FULL = `/${ROUTE_PREFIX_TRIMMED}/`;
